import { render, staticRenderFns } from "./AttachCustomersToLevel.vue?vue&type=template&id=23d64ea6&"
import script from "./AttachCustomersToLevel.vue?vue&type=script&lang=js&"
export * from "./AttachCustomersToLevel.vue?vue&type=script&lang=js&"
import style0 from "./AttachCustomersToLevel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports